import "./styles/mediumTableDetailCard/mediumTableDetailCard.css";

import React, { useEffect, useState } from "react";

import { withNamespaces } from "react-i18next";

import MediumTable from "../../components/Table/MediumTable/MediumTable";
import WhiteButton from "../../components/form_components/Buttons/WhiteButton/WhiteButton";
import { AuthContextValue } from "../../context/AuthContext";
import { GetContextValue } from "../../context/GetContext";
import useFetch from "../../hooks/UseFetch";
import Loading from "../../components/Loading/Loading";
import { Link } from "react-router-dom";
import ErrorComponent from "../../components/ErrorComponent/ErrorComponent";

function OpportunitiesCard({ t }) {
  const { token, loginUserCompanyId, userRole } = AuthContextValue();
  const { notificationRender } = GetContextValue();

  /* Tablodan seçilen değerleri tutan stateler */
  const [selectValue, setSelectValue] = useState(null);
  const [selectValueId, setSelectValueId] = useState(null);

  const opportunitiesStatus = userRole === "Manager" ? 1 : 2;

  const {
    setUseFetchRender: setOpportunitiesWaitingForOfferUseFetchRender,
    useFetchRender: opportunitiesWaitingForOfferUseFetchRender,
    error: opportunitiesWaitingForOfferError,
    loading: opportunitiesWaitingForOfferLoading,
    data: opportunitiesWaitingForOffer,
    total: opportunitiesWaitingForOfferTotal,
  } = useFetch(
    `${
      process.env.REACT_APP_GET_TENDER_SUPPLIER_LIST_URL
    }?Count=0&SortType=${3}&Status=${opportunitiesStatus}&CompanyId=${loginUserCompanyId}&Page=${1}&PageSize=${5}`,
    token
  );

  const columns = [
    {
      key: "companyName",
      header: t("table_company_name"),
    },
    {
      key: "productName",
      header: t("table_product"),
    },
    {
      key: "remainingTime",
      header: t("table_remaining_time"),
    },
    {
      key: "distance",
      header: t("table_distance"),
    },
  ];

  useEffect(() => {
    setOpportunitiesWaitingForOfferUseFetchRender(
      !opportunitiesWaitingForOfferUseFetchRender
    );
  }, [notificationRender]);

  // useEffect(() => {
  //   setOpportunitiesWaitingForOfferUseFetchRender(
  //     !opportunitiesWaitingForOfferUseFetchRender
  //   );
  // }, []);

  /* sayfaya girdiğimizde contextte var olan veriyi siler */
  useEffect(() => {
    setSelectValue(null);
    setSelectValueId(null);
  }, []);

  function handleClickValue(valueId, value) {
    setSelectValueId(valueId);
    setSelectValue(value);
  }

  console.log("opportunitiesWaitingForOffer : ",opportunitiesWaitingForOffer);

  return (
    <div className="medium-table-container">
      <div className="table-top">
        <div className="title-box">
          <i className="fa-solid fa-star"></i>
          <h5>{t("opportunities_title")}</h5>
        </div>
        <div className="buttons">
          <WhiteButton
            icon={<i className="fa-solid fa-arrow-rotate-left"></i>}
            tooltip={t("button_edit_render")}
            onClick={() => {
              setSelectValue(null);
              setSelectValueId(null);
              setOpportunitiesWaitingForOfferUseFetchRender(
                !opportunitiesWaitingForOfferUseFetchRender
              );
            }}
          />
          <Link
            to={
              selectValue || selectValueId
                ? `opportunities/tender-detail-offer/${selectValueId}`
                : false
            }
          >
            <WhiteButton
              disabled={selectValue || selectValueId ? false : true}
              icon={<i className="fa-solid fa-info"></i>}
              tooltip={t("button_edit_detail")}
            />
          </Link>
        </div>
      </div>

      <div className="table-main">
        {opportunitiesWaitingForOfferError ? (
          <ErrorComponent error={opportunitiesWaitingForOfferError} />
        ) : opportunitiesWaitingForOfferLoading ? (
          <Loading />
        ) : opportunitiesWaitingForOffer !== null &&
          opportunitiesWaitingForOffer.length > 0 ? (
          <MediumTable
            type="opportunities"
            selectValueId={selectValueId}
            selectValue={selectValue}
            handleClickValue={handleClickValue}
            columns={columns}
            data={opportunitiesWaitingForOffer}
          />
        ) : (
          <div className="table-null-text">{t("message_no_waiting_offer_opportunities")}</div>
        )}
      </div>
    </div>
  );
}

export default withNamespaces()(React.memo(OpportunitiesCard));
